import BaseRepository from './base-repository';

import { Metadata } from '@/modules/metadata/types/Metadata';
import { Media } from '@/types/Media';

export default class MediaMetadataRepository extends BaseRepository<Metadata> {
  constructor(media: Media) {
    super(`/media/${media.id}/metadata`);
  }
}
